import { UPDATE_LOCATION } from './constants';

export const updateLocationAction = ({ instrumentId, location }) => ({
    type: UPDATE_LOCATION,
    instrumentId,
    location
});
